
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, UntypedFormBuilder, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { CommonBindingDataService } from '../../services/common-binding-data.service';
import { ToastMessageOptions } from 'primeng/api';

import { AppSettings } from '../../../shared/app.settings';
import { StorageService } from './../../services/storage.service';
import { UiService } from './../../services/ui.service';
import { UserCommonService } from './../../services/user-common.service';
import { ErrorBindingService } from '../../services/error-binding.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
})
export class ForgotPasswordComponent implements OnInit {
  @Output() popClose: EventEmitter<any> = new EventEmitter();
  @Output() popSave: EventEmitter<any> = new EventEmitter();
  forgotPasswordErrors = [
    {
      username: false
    }
  ];
  message: ToastMessageOptions[] = [];
  editforgotForm = new UntypedFormGroup({
    username: new UntypedFormControl()
  });



  constructor(
    private formBuilder: UntypedFormBuilder,
    private storageService: StorageService,
    private translate: TranslateService,
    private commonServices: UserCommonService,
    private uiSerice: UiService,
    private commonBindingDataService: CommonBindingDataService,
    private errorBindingService: ErrorBindingService
  ) { }

  ngOnInit() {
    this.editforgotForm = this.formBuilder.group({
      username: ['', [Validators.required, Validators.pattern(AppSettings.EMAIL_PATTERN)]],
    });
  }

  closeEditForgot(event) {
    this.editforgotForm.reset();
    this.popClose.emit();
  }

  changePassword(event) {
    this.message = [];
    let input;
    let otpEmail;
    let otpPhone;

    const userName = this.editforgotForm.controls.username.value;
    if (userName.match(AppSettings.EMAIL_PATTERN)) {
      otpEmail = userName;
      input = {
        email: userName,
        tenantId: AppSettings.TENANT
      };
    } else if (userName.match(AppSettings.PHONE_PATTERN)) {
      otpPhone = userName;
      input = {
        phoneNum: userName,
        tenantId: AppSettings.TENANT
      };
    } else {
      input = {
        username: userName,
        tenantId: AppSettings.TENANT
      };
    }
    this.commonServices.forgotPassword(JSON.stringify(input)).subscribe(results => {
      results.email = otpEmail;
      results.phone = otpPhone;
      this.popSave.emit(results);
      this.editforgotForm.reset();
    }, (error) => {
      this.errorBindingService.onAPIValidationError(error, this.forgotPasswordErrors);
    });
  }
}
